import { browserHistory } from 'react-router'

import { queueTrackingEvent } from '@library/tracking-integration'

import { CONTROL_PROMO_CODE } from '../config/discountBoxes'
import type { PaidSearchBrandTrackingEventType } from '../tracking/trackingConfig'

const signupUri = '/signup'

export const redirectToWizard = (
  trackingEvent: PaidSearchBrandTrackingEventType,
  ctaUri: string,
) => {
  const params = new URLSearchParams(window.location.search)
  const discountCode = params.get('promo_code') || CONTROL_PROMO_CODE

  queueTrackingEvent<PaidSearchBrandTrackingEventType>(trackingEvent)

  if (ctaUri !== signupUri) {
    browserHistory.push(ctaUri)

    return
  }

  browserHistory.push(`/signup/box-size?promo_code=${discountCode}`)
}
